export default __webpack_public_path__ + "static/media/Pulley for Bucket Elevator.30d77523.jpg";